import request from "../request";

export class ItemSetService {
  
  static get = async () => {
    return await request.get(`/item_sets`);
  };

}